<template>
    <div>
        <div id='product-reviews-scroll'></div>
        <div class='container'>
            <div class='reviews-container'>
                <div class='title'>Reviews</div>
                    <div class='filter-reviews-container'>
                        <FilterReviewsByStar :star_filters='star_filters' @reviewFilterListener='filterReviews'/>
                        <ReviewSummary :total_reviews='total_reviews' :average_rating='average_rating' />
                    </div>

                <div v-for='review in reviews' :key='review.id'>
                    <Review :review='review'/>
                </div>

                <Pagination name="review_pagination" :pagination_data="pagination_data" :total_rows="total_reviews" @paginationClickListener="paginationClick"/>

            </div>
        </div>
    </div>
</template>

<script>
import Ratings from '@/ecom/components/products/single_product/reviews/Ratings.vue';
import Review from '@/ecom/components/products/single_product/reviews/Review.vue';
import FilterReviewsByStar from '@/ecom/components/products/single_product/reviews/FilterReviewsByStar.vue';
import ReviewSummary from '@/ecom/components/products/single_product/reviews/ReviewSummary.vue';
import Pagination from '@/ecom/components/pagination/Pagination.vue';
import {checkAuth} from "@/global/modules/functions.js";

export default {
    // props: ['reviews', 'total_reviews', 'average_rating', 'star_filters'],
    props: ['product_on_popout', 'product_id', 'product_code_changed_watcher'],
    components: {Ratings, Review, FilterReviewsByStar, ReviewSummary, Pagination},
    emits: ['reviewsListener'],
    data(){
        return{
            review_search: '',
            reviews: [],
            total_reviews: 0,
            star_filters: {},
            average_rating: 0,
            filter_by_rating: 0,
            pagination_data:{
                rows_per_page : 20,
                current_page : 1,
                starting_row_number : 0,
                ending_row_number : 0,
            }
        }
    },
    methods:{
        async getReviews(){
            let product_id = '';
            if(!this.product_on_popout){
                let params = this.$route.params;
                product_id = params.product_id;
            }
            else{
                product_id = this.product_id;
            }

            let response = await fetch(`/api/product/reviews?product_code=${product_id}&filter_by_rating=${this.filter_by_rating}&pagination_data=${JSON.stringify(this.pagination_data)}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.reviews = results.reviews;
                this.average_rating = results.average_rating;
                this.total_reviews = results.total_reviews;
                this.star_filters = results.star_filters;
                this.$emit('reviewsListener', this.total_reviews, this.average_rating);
            }
        },
        filterReviews(rating){
            this.filter_by_rating = rating
            this.getReviews();
        },
        paginationClick(name, current_page_number, starting_row_number, ending_row_number){
            this.pagination_data.current_page = current_page_number;
            this.pagination_data.starting_row_number = starting_row_number;
            this.pagination_data.ending_row_number = ending_row_number;
            this.getReviews();
            this.ScrollToReviews();
        },
        ScrollToReviews(){
            const y_offset = 50; 
            const element = document.getElementById('product-reviews-scroll');
            const y = element.getBoundingClientRect().top + window.pageYOffset + y_offset;
            
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    },
    beforeMount(){
        if(!this.product_on_popout){
            this.getReviews();
        }
    },
    watch:{
        'product_code_changed_watcher': function(){
            this.review_search = '',
            this.reviews = [],
            this.total_reviews = 0,
            this.star_filters = {},
            this.average_rating = 0,
            this.filter_by_rating = 0,
            this.pagination_data ={
                rows_per_page : 20,
                current_page : 1,
                starting_row_number : 0,
                ending_row_number : 0,
            }

            if(this.product_on_popout){
                this.getReviews();
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.container{
    display: flex;
    justify-content: center;
}

.filter-reviews-container{
    background-color: #f1f3f5;
    width: 100%;
    padding: 20px 50px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 20px;
    @media(max-width: 768px){
        padding: 20px 30px;
    }
}

.reviews-container{
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items:  center;
    width: 1000px;

    @media(max-width: 1000px){
        width: 80%;
    }
}

.filter-reviews-section{
    display: flex;
    align-items: center;
}

.title{
    font-size: 1.8rem;
    color: var(--black);
}

.number-of-reviews-text{
    color: #495057;
    font-size: 0.95rem;
}

.search-bar{
    width: 300px;
    height: 40px;
    border-radius: 2px;
    border: solid 0.5px #dee2e6;
    padding: 1px 35px 1px 20px;
    font-size: 1rem;
    font-size: 0.9rem;
}

.search-bar-icon{
    z-index: 3;
    margin-left: -30px;
    width: 25px;
    color: var(--primary-colour-2);
    font-size: 1rem;
}

.clear-search-icon{
    cursor: pointer;
}
</style>